import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonRestService } from './CommonRest.service';
import { environment } from '../../environments/environments';

@Injectable({ providedIn: 'root' })
export class BusinessCommonService {
  constructor(private commonService: CommonRestService) {}

  getResourcesByName(searchText: string): Observable<unknown> {
    return this.commonService.commonGet(`/search/getResourceByName?searchText=${encodeURIComponent(searchText)}`);
  }

  saveCollectionData(subListId: string | number, customerInfoExt: unknown): Observable<unknown> {
    return this.commonService.commonPost(
      `${environment.baseUrl}/api/business/saveCollection/${subListId}`,
      customerInfoExt
    );
  }

  updateCollectionData(subListId: string | number, customerInfoExt: unknown): Observable<unknown> {
    return this.commonService.commonPost(
      `${environment.baseUrl}/api/business/update-collection/${subListId}`,
      customerInfoExt
    );
  }

  getSubfileMetaData(listId: string): Observable<unknown> {
    return this.commonService.commonGet(`${environment.baseUrl}/api/business/getMetaData?subListId=${encodeURIComponent(listId)}`);
  }

  getfieldsMetaData(listId: number): Observable<unknown> {
    return this.commonService.commonGet(`${environment.baseUrl}/api/get-fields-meta?subListId=${listId}`);
  }

  getSubfileMetaFieldsMap(listId: string, file: unknown): Observable<unknown> {
    return this.commonService.commonPost(`${environment.baseUrl}/api/get-fields/${encodeURIComponent(listId)}`, file);
  }

  saveSubfileMetaFieldsMap(listId: string, datas: unknown): Observable<unknown> {
    return this.commonService.commonPost(`${environment.baseUrl}/api/saveSubFileMetaFieldMap/${encodeURIComponent(listId)}`, datas);
  }

  getSubfileMetaDataById(listId: string, id: number, isMaker: boolean | string | number): Observable<unknown> {
    const url =
      `${environment.baseUrl}/api/get-subdata-by-id?subListId=${encodeURIComponent(listId)}` +
      `&id=${id}&isMaker=${encodeURIComponent(String(isMaker))}`;
    return this.commonService.commonGet(url);
  }

  deleteData(listId: string | number, data: unknown): Observable<unknown> {
    const url = `${environment.baseUrl}/api/business/delete-collection/${listId}`;
    return this.commonService.commonPostWithReqBody(url, data);
  }

  getSubListPositionMap(subListIdnty: string | number, pageType: string | number): Observable<unknown> {
    const url = `${environment.baseUrl}/api/business/getSubListpositionMap/`;
    return this.commonService.commonGetWithPathVariables(url, subListIdnty, pageType);
  }

  getUploadListPositionsMap(subListIdnty: string | number, uploadId: string | number): Observable<unknown> {
    const url = `${environment.baseUrl}/api/business/getUploadListpositionsMap/`;
    return this.commonService.commonGetWithPathVariables(url, subListIdnty, uploadId);
  }

  getUserListByIdList(idList: number[]): Observable<unknown> {
    const url = `${environment.baseUrl}/sc/api/user/get-user-profile-list`;
    return this.commonService.commonPostWithReqBody(url, idList);
  }
}
